import { useCallback } from 'react';

import { useLocation } from 'react-router-dom';

import { Cluster } from '@cast/types';

import { useIsSecuritySunsetEnabled } from 'features/organization/security-insights/hooks/useIsSecuritySunsetEnabled';
import { useNavigate } from '@cast/infrastructure-organization';

import { FeatureSelection } from '../types';
import { generateRedirectPath } from '../utils';

export function useDefaultPhase2SuccessNavigation() {
  const location = useLocation();
  const navigate = useNavigate();
  const isSecuritySunsetEnabled = useIsSecuritySunsetEnabled();

  return useCallback(
    (cluster: Cluster, enabledFeatures: FeatureSelection) => {
      const isInSecurityPage =
        !isSecuritySunsetEnabled &&
        location.pathname.includes('organization/security');
      const redirectPath = generateRedirectPath({
        enabledFeatures,
        cluster,
        isInSecurityPage,
        isSecuritySunsetEnabled,
      });

      if (redirectPath && redirectPath !== location.pathname) {
        navigate({ pathname: redirectPath });
      }
    },
    [location.pathname, navigate, isSecuritySunsetEnabled]
  );
}
